export const getSalesPromotionParams = (state) => {
  if (state && state.salesPromotion) {
    return Object.entries(state.salesPromotion).reduce((acc, [param, value]) => {
      if (value) {
        return {
          ...acc,
          [param]: value
        };
      }
      return acc; // return the accumulator when the value is null or undefined
    }, {});
  }

  return {};
};
